import {
  districtsData,
  districtsDataLoading,
  streetsNumbersData,
  streetsNumbersDataLoading,
} from '../../redux/features/dashboard/dashboardSelectors';
import { validationSchema } from '../validationSchema';
import { equipmentInitialValues } from './add-realty-mock/equipment-mock';

export const booleanValues = {
  is_address_checked: '',
  is_vefa: '',
};

export const initialValues = {
  city_id: '',
  name: '',
  district_id: '',
  street_id: '',
  street_number_id: '',
  ...booleanValues,
  build_date: '',
  comment: '',
  description: '',
  image: '',
  ...equipmentInitialValues,
};

export const validationSchemaResidence = {
  city_id: validationSchema.default,
  name: validationSchema.default,
};

export const mockAccordionTitlesResidence = {
  Main: 'Main',
  Notes: 'Notes',
  Equipment: 'Equipment',
  Photo: 'Photo',
};

export const mock = [
  {
    title: 'Main',
    id: 1,
    placeholder: 'Name',
    fieldType: 'text',
    name: 'name',
    classNames: 'w-full',
  },
  {
    title: 'Main',
    listId: 'listId',
    id: 2,
    placeholder: 'District',
    fieldType: 'selectDepedent',
    selectDepedentData: districtsData,
    selectDepedentDataLoading: districtsDataLoading,
    name: 'district_id',
    classNames: 'w-full',
  },
  {
    title: 'Main',
    listId: 'listId',
    id: 3,
    placeholder: 'Street number',
    fieldType: 'selectDepedent',
    selectDepedentData: streetsNumbersData,
    selectDepedentDataLoading: streetsNumbersDataLoading,
    name: 'street_number_id',
    classNames: 'w-1/2',
  },
  {
    title: 'Main',
    listId: 'listId',
    id: 4,
    checkboxText: 'Address checked',
    name: 'is_address_checked',
    fieldType: 'checkbox',
    classNames: 'w-max',
  },
  {
    title: 'Main',
    listId: 'listId1',
    id: 5,
    placeholder: 'Date of construction',
    fieldType: 'text',
    name: 'build_date',
    classNames: 'w-1/2',
  },
  {
    title: 'Main',
    listId: 'listId1',
    id: 6,
    checkboxText: 'VEFA',
    name: 'is_vefa',
    fieldType: 'checkbox',
    classNames: 'w-max',
  },
  {
    title: 'Notes',
    id: 6,
    placeholder: 'Write Estate Comment',
    fieldType: 'textarea',
    name: 'comment',
    classes: 'h-20',
    classNames: 'w-full',
  },
  {
    title: 'Notes',
    id: 7,
    placeholder: 'Description',
    fieldType: 'textarea',
    name: 'description',
    classes: 'h-20',
    classNames: 'w-full',
  },
  {
    title: 'Equipment',
    subtitle: 'Facilities',
    id: 11,
    fieldType: 'checkboxList',
    name: 'facilities',
    checkboxes: [
      {
        checkboxText: 'Water softener',
        value: 1,
        name: 'residence_facilities_water_softener',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Air conditioning',
        value: 2,
        name: 'residence_facilities_conditioning',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Central vacuum',
        value: 3,
        name: 'residence_facilities_vacuum',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Spa bath',
        value: 4,
        name: 'residence_facilities_spa',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Fireplace',
        value: 5,
        name: 'residence_facilities_fireplace',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Smart home',
        value: 6,
        name: 'residence_facilities_smart_home',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Double glazing',
        value: 7,
        name: 'residence_facilities_glazing',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Sliding windows',
        value: 8,
        name: 'residence_facilities_sliding_windows',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Internet',
        value: 9,
        name: 'residence_facilities_internet',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Jacuzzi',
        value: 10,
        name: 'residence_facilities_jacuzzi',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Caretaker`s house',
        value: 11,
        name: 'residence_facilities_caretaker_house',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Furnished',
        value: 12,
        name: 'residence_facilities_furnished',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Awning',
        value: 13,
        name: 'residence_facilities_awning',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Electric awning',
        value: 14,
        name: 'residence_facilities_electric_awning',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Smart thermostat',
        value: 15,
        name: 'residence_facilities_smart_thermostat',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Triple glazing',
        value: 16,
        name: 'residence_facilities_triple_glazing',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Electric shutters',
        value: 17,
        name: 'residence_facilities_shutters',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
  {
    title: 'Equipment',
    subtitle: 'Building',
    id: 11,
    fieldType: 'checkboxList',
    name: 'buildings',
    checkboxes: [
      {
        checkboxText: 'Access for people with reduced mobility',
        value: 1,
        name: 'residence_buildings_access',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Elevator',
        value: 2,
        name: 'residence_buildings_elevator',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Laundry',
        value: 3,
        name: 'residence_buildings_laundry',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Fiber optics',
        value: 4,
        name: 'residence_buildings_fiber_optics',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Satellite dish',
        value: 5,
        name: 'residence_buildings_satellite_dish',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Videophone',
        value: 6,
        name: 'residence_buildings_videophone',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Cinema',
        value: 7,
        name: 'residence_buildings_cinema',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Wine cellar',
        value: 8,
        name: 'residence_buildings_wine_cellar',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
  {
    title: 'Equipment',
    subtitle: 'Security',
    id: 11,
    fieldType: 'checkboxList',
    name: 'securities',
    checkboxes: [
      {
        checkboxText: 'Alarm',
        value: 1,
        name: 'residence_securities_alarm',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Safe',
        value: 2,
        name: 'residence_securities_safe',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Digicode',
        value: 3,
        name: 'residence_securities_digicode',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Guard',
        value: 4,
        name: 'residence_securities_fiber_optics',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Interphone',
        value: 5,
        name: 'residence_securities_interphone',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Electric gates',
        value: 6,
        name: 'residence_securities_electric_gates',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Armored door',
        value: 7,
        name: 'residence_securities_armored_door',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Video surveillance',
        value: 8,
        name: 'residence_securities_surveillance',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
  {
    title: 'Equipment',
    subtitle: 'Sport facilities',
    id: 11,
    fieldType: 'checkboxList',
    name: 'sports',
    checkboxes: [
      {
        checkboxText: 'Golf',
        value: 1,
        name: 'residence_sports_golf',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Lawn bowls',
        value: 2,
        name: 'residence_sports_lawn_bowls',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Swimming pool',
        value: 3,
        name: 'residence_sports_pool',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Sauna',
        value: 4,
        name: 'residence_sports_sauna',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Spa',
        value: 5,
        name: 'residence_sports_spa',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Tennis',
        value: 6,
        name: 'residence_sports_tennis',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Playground',
        value: 7,
        name: 'residence_sports_playground',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Ping-pong',
        value: 8,
        name: 'residence_sports_pinpong',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Gym',
        value: 9,
        name: 'residence_sports_gym',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
  {
    title: 'Equipment',
    subtitle: 'Exterior spaces',
    id: 11,
    fieldType: 'checkboxList',
    name: 'exterior_spaces',
    checkboxes: [
      {
        checkboxText: 'Carport',
        value: 1,
        name: 'residence_exterior_spaces_carport',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Automatique irrigation',
        value: 2,
        name: 'residence_exterior_spaces_irrigation',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Barbeque',
        value: 3,
        name: 'residence_exterior_spaces_barbeque',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'External lighting',
        value: 4,
        name: 'residence_exterior_spaces_light',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Well',
        value: 5,
        name: 'residence_exterior_spaces_well',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Heliport',
        value: 6,
        name: 'residence_exterior_spaces_heliport',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Water well',
        value: 7,
        name: 'residence_exterior_spaces_water_well',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Fountain',
        value: 8,
        name: 'residence_exterior_spaces_fountain',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Patio',
        value: 9,
        name: 'residence_exterior_spaces_patio',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
      {
        checkboxText: 'Pool house',
        value: 10,
        name: 'residence_exterior_spaces_pool_house',
        fieldType: 'checkbox',
        classNames: 'w-max',
      },
    ],
    classNames: 'w-full',
  },
];
